import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from 'react';
import { Box } from '@mui/material';
import ScrollingDLCContainer from "./ScrollingDLCContainer";
import ModalSelectPlatform from "./ModalSelectPlatform";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EStoreProductDetailDownloadable = ({
  listItemDLC,
  titleButtonBuyNowDigital,
  titleModalSelectPlatform,
  onClickBuy
}) => {
  const [showModalPlatform, setShowModalPlatform] = useState(false);
  const [itemBuy, setItemBuy] = useState({});
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: {
        xs: "72px 0px",
        lg: "80px 0px"
      },
      background: "#F9F9F9"
    },
    className: "store-games-detail-download-ble",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        "& button": {
          background: 'transparent'
        }
      },
      children: /*#__PURE__*/_jsx(ScrollingDLCContainer, _extends({}, listItemDLC, {
        onClickBuyItem: item => {
          setItemBuy(item);
          setShowModalPlatform(true);
        }
      }))
    }), /*#__PURE__*/_jsx(ModalSelectPlatform, {
      open: showModalPlatform,
      onClose: () => setShowModalPlatform(false),
      titleModalSelectPlatform: titleModalSelectPlatform,
      listPlatform: itemBuy?.platformList,
      titleButtonBuy: titleButtonBuyNowDigital,
      onClickBuy: value => onClickBuy?.(_extends({
        id: itemBuy?.id
      }, value))
    })]
  });
};
export default EStoreProductDetailDownloadable;